import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
// import { AllLoadingEquipmentClearenceReport } from "../../../Apis/TransferStationReport/primaryDeploymentTransactionReportApi";
import {
  AllLoadingEquipment,
  AllLoadingEquipmentClearenceReport,
} from "../../../Apis/loadingEquipmentApi";
import TableComponent from "../../../Common/TableComponent/tableComponent";
import { TableLoader } from "../../../Common/ShimmerLoader";
import * as XLSX from "xlsx";
import ExcelJS from "exceljs";
import { CreatableSelect } from '@atlaskit/select';
import { AllOwnerTypeDetails } from "../../../Apis/ownerTypeApi";
import { AllVehicleTypeDetails } from "../../../Apis/vehicleApi";
import isGHMC from "../../../Common/helper/helpar";
const LoadingEquipmentClearenceReport = ({ t }) => {
  const headers = [
    "zone",
    "circle",
    "ward",
    "loadingEquipment",
    "taggedVehicleNumber",
    "ownerType",
    "vehicleType",
    "driverInfo",
    "beforeDateAndTime",
    "afterDateAndTime",
    "clearedDuration",
    "latitude",
    "longitude",
    "beforeImage",
    "afterImage",
  ];

  const [getAllTripsTonnage, setAllTripsTonnage] = useState([]);
  const [startDate, setStartDate] = useState(getStartOfCurrentDate());
  const [endDate, setEndDate] = useState(getCurrentDateTime());
  const [isLoading, setIsLoading] = useState(false);
  const [optionsLoadingValues, setOptionLoadingValues] = useState([]);
  const [selectedOwnerType, setSelectedOwnerType] = useState([]);
  const [selectedVehicleType, setSelectedVehicleType] = useState([]);
  const [selectedLoadingEquipment, setSelectedLoadingEquipment] = useState([]);
  const startDateTime = localStorage.getItem("startDate")
  const endDateTime = localStorage.getItem("endDate")
  const [optionsValues, setOptionsValues] = useState([]);
  const [vehicleTypeOptionsValues, setVehicleTypeOptionsValues] = useState([]);
  const [selectedShift, setSelectedShift] = useState("1");
  const [ownerTypeDetails, setOwnerTypeDetails] = useState([]);
  const [vehicleTypeDetails, setVehicleTypeDetails] = useState([]);
  const [opts, setOpts] = useState(optionsLoadingValues);
  const [loadingEquipments, setLoadingEquipments] = useState([]);
  const isProd = isGHMC();
  useEffect(() => {
    fetchTripsTonnageData(startDate, endDate);
  }, []);


  useEffect(() => {
    const fetchOwnerTypeData = async () => {
      try {
        const ownerTypeData = await AllOwnerTypeDetails();
        setOwnerTypeDetails(ownerTypeData);
      } catch (error) {
        console.error("Error fetching owner type data:", error);
      }
    };

    fetchOwnerTypeData();
  }, []);

  useEffect(() => {
    const fetchVehicleTypeData = async () => {
      try {
        const vehicleTypeData = await AllVehicleTypeDetails();
        setVehicleTypeDetails(vehicleTypeData);
      } catch (error) {
        console.error("Error fetching owner type data:", error);
      }
    };

    fetchVehicleTypeData();
  }, []);
  const timeToSeconds = (time) => {
    if (!time) return 0; // Handle empty values
    const parts = time.split(":").map(Number);
    if (parts.length === 3) {
      return parts[0] * 3600 + parts[1] * 60 + parts[2]; // HH:mm:ss
    } else if (parts.length === 2) {
      return parts[0] * 60 + parts[1]; // mm:ss
    }
    return 0;
  };
 
  // Convert total seconds back to HH:mm:ss format
  const secondsToTime = (seconds) => {
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
  };
 
 
  // Function to calculate totals (including time-based fields)
  const calculateTotals = (data) => {
    return data.reduce(
      (totals, row) => {
        totals.clearedDuration += timeToSeconds(row.clearedDuration);
        return totals;
      },
      {
        clearedDuration: 0,
      }
    );
  };
 
  // Add a total row with properly formatted time values
  const addTotalRow = (data) => {
    if (!data.length) return data;
 
    const totals = calculateTotals(data);
 
    return [
      ...data,
      {
        afterDateAndTime: "Total",
        clearedDuration: secondsToTime(totals.clearedDuration),
        beforeImage: "", // Ensure beforeImage is empty
        afterImage: "",  // Ensure afterImage is empty
      },
    ];
  };

  const fetchTripsTonnageData = async (startDate, endDate) => {
    try {
      setIsLoading(true);
      const response = await AllLoadingEquipmentClearenceReport(
        startDate,
        endDate,
        selectedOwnerType,
        selectedVehicleType,
        selectedLoadingEquipment,
      );
      const formattedData = response.map((item) => ({
        ...item,
        zone: item.zoneName || "N/A", // Include vehicleImageUrl in the data
        circle: item.circleName || "N/A",
        ward: item.wardName || "N/A",
        loadingEquipment: item.loadingEquipmentNumber || "N/A",
        taggedVehicleNumber: item.taggedVehicleNumber || "N/A",
        ownerType: item.ownerTypeName || "N/A",
        vehicleType: item.vehicleTypeName || "N/A",
        driverInfo: `${item.driverName}-${item.driverMobileNumber}` || "N/A",
        // driver: item.driverName || "N/A",
        // driverNumber: item.driverMobileNumber || "N/A",
        beforeDateAndTime: item.beforeDateTime || "N/A",
        afterDateAndTime: item.afterDateTime || "N/A",
        latitude: item.afterLatitude || "N/A",
        longitude: item.afterLongitude || "N/A",
        beforeImage: item.beforeImageUrl,
        afterImage: item.afterImageUrl,
        clearedDuration: item.clearedDuration || "N/A"
      }));
      setAllTripsTonnage(addTotalRow(formattedData));
      setIsLoading(false); // After data fetching is done, set isLoading to false
    } catch (error) {
      console.log(error);
      setIsLoading(false); // In case of error, also set isLoading to false
    }
  };

  useEffect(() => {
    const fetchLoadingEquipments = async () => {
      try {
        const loadingEquipmentsData = await AllLoadingEquipment();
        setLoadingEquipments(loadingEquipmentsData);
      } catch (error) {
        console.error("Error fetching loading equipments:", error);
      }
    };

    fetchLoadingEquipments();
  }, []);




 
  const options = { day: 'numeric', month: 'numeric', year: 'numeric' };
  const generationTime = ` ${new Date().toLocaleString('en-GB', options).replace(/\//g, '/')}`;

  const downloadAsExcel = async () => {
    // Create a new workbook and add a worksheet
    const currentDate = new Date();
    const formattedDate = `${currentDate.getFullYear()}-${
      currentDate.getMonth() + 1
      }-${currentDate.getDate()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const downloadDateTime = `LoadingEquipmentClearanceReport Generated on: ${generationTime},${formattedTime}`;
    // Calculate the length of the downloadDateTime string
    const downloadDateTimeLength = downloadDateTime.length;
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("LoadingEquipment");

    // Define styles
    const boldFont = { bold: true };

    // Add the downloadDateTime to the correct row and columns, and ensure formatting
    worksheet.addRow(["", "", downloadDateTime, ""]); // Update array length to match new cell range
    worksheet.mergeCells(1, 2, 1, 7); // Merge cells for downloadDateTime from column 2 to 4
    worksheet.getCell(1, 2).value = downloadDateTime; // Ensure the value is set after merging
    worksheet.getCell(1, 2).font = boldFont; // Set font style
    worksheet.getCell(1, 2).alignment = { horizontal: "center" }; // Center align the content

    // Apply styles to the merged cells (B1, C1, D1)
    for (let col = 2; col <= 4; col++) {
      worksheet.getCell(1, col).font = boldFont; // Set styles individually
      worksheet.getCell(1, col).alignment = { horizontal: "center" }; // Center align the cell content
    }

    // Add "Zone Details" to the correct row and columns, and ensure formatting
    worksheet.addRow(["", "", "Loading Equipment Clearance Report", ""]); // Update array length to match new cell range
    worksheet.mergeCells(2, 2, 2, 7); // Merge cells for Zone Details from column 2 to 4
    worksheet.getCell(2, 2).value = "Loading Equipment Clearance Report"; // Ensure the value is set after merging
    worksheet.getCell(2, 2).font = boldFont; // Set font style
    worksheet.getCell(2, 2).alignment = { horizontal: "center" }; // Center align the content

    // Apply styles to the merged cells (B2, C2, D2)
    for (let col = 2; col <= 4; col++) {
      worksheet.getCell(2, col).font = boldFont; // Set styles individually
      worksheet.getCell(2, col).alignment = { horizontal: "center" }; // Center align the cell content
    }
    const tableHeaderRow = worksheet.addRow([
      "S.No",
          "Zone",
          "Circle",
          "Ward",
          "Loading Equipment",
          "Tagged Vehicle Number",
          "Owner Type",
          "Vehicle Type",
          "Driver Info",
          "Before Date and Time",
          "After Date and Time",
          "Cleared Duration",
          "Latitude",
          "Longitude",
    ]);
    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "left",color:"#fff" }; // Center align the cell content
      if (colNumber >= 1 && colNumber <= 14) {
        // Apply background color and set text color
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "F6B1B1" }, // Red background color
          bgColor: { argb: "FFFFFFFF" } // White text color
        };
      }
    });

    // Add data rows
    getAllTripsTonnage.forEach((item, index) => {

      worksheet
        .addRow([
          index + 1,
          item.zoneName?? "N/A",
          item.circleName?? "N/A",
          item.wardName?? "N/A",
          item.loadingEquipmentNumber?? "N/A",
          item.taggedVehicleNumber?? "N/A",
          item.ownerTypeName?? "N/A",
          item.vehicleTypeName?? "N/A",
          item.driverInfo?? "N/A",
          item.beforeDateTime?? "N/A",
          item.afterDateAndTime?? "N/A",
          item.clearedDuration?? "N/A",
          item.afterLatitude?? "N/A",
          item.afterLongitude?? "N/A"
        ])
        .eachCell({ includeEmpty: true }, (cell, colNumber) => {
          if (colNumber >= 1 && colNumber <= 14) {
            // Align the columns from 1 to 4 to the left
            cell.alignment = { horizontal: "left" };
          } else {
            // Align the rest of the columns to the center
            cell.alignment = { horizontal: "center" };
          }
        });
    });

    // Add total row with bold font


    // Set column widths dynamically based on content
    worksheet.columns = [
      { width: 5 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
    ];

    // Save the workbook to a file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "LoadingEquipmentClearanceReport.xlsx";
    a.click();
    URL.revokeObjectURL(url);
  };
  const handleFormSubmit = (e) => {
    e.preventDefault();
    fetchTripsTonnageData(
      startDate,
      endDate,
      selectedOwnerType,
      selectedLoadingEquipment,
      selectedShift,
      selectedVehicleType
    );
  };
  const handleChange = (newValue, actionMeta) => {
    if (actionMeta.action === 'select-option') {
      setSelectedOwnerType(newValue.value);
    } else if (actionMeta.action === 'create-option') {
      const newValueOption = { label: newValue.label, value: newValue.value };
      setSelectedOwnerType(newValue.value);
      // Add logic to update optionsValues with the new option if needed
    } else {
      if (actionMeta.action === 'clear') {
        setSelectedOwnerType(null); // Ensure selectedOwnerType is cleared
      }
    }
  };

  const handleVehicleTypeChange = (newValue, actionMeta) => {
    if (actionMeta.action === 'select-option') {
      setSelectedVehicleType(newValue.value);
    } else if (actionMeta.action === 'create-option') {
      const newValueOption = { label: newValue.label, value: newValue.value };
      setSelectedVehicleType(newValue.value);
      // Add logic to update optionsValues with the new option if needed
    } else {
      if (actionMeta.action === 'clear') {
        setSelectedVehicleType(null); // Ensure selectedOwnerType is cleared
      }
    }
  };
  const handleLoadingEquipmentChange = (newValue, actionMeta) => {
    if (actionMeta.action === 'select-option') {
      setSelectedLoadingEquipment(newValue.value);
    } else if (actionMeta.action === 'create-option') {
      const newValueOption = { label: newValue.label, value: newValue.value };
      setSelectedLoadingEquipment(newValue.value);
      // Add logic to update optionsValues with the new option if needed
    } else {
      if (actionMeta.action === 'clear') {
        setSelectedLoadingEquipment(null); // Ensure selectedOwnerType is cleared
      }
    }
  };
  const handleCreateOption = (inputValue) => {
    if (inputValue) {
      const newValue = { label: inputValue, value: inputValue.toLowerCase()};
      setOpts((prevOptions) => [...prevOptions, newValue]);
      if (typeof selectedLoadingEquipment === 'function') {
        selectedLoadingEquipment(newValue.value);
      } else {
        console.error('selectedLoadingEquipment is not a function');
      }
    }
  };
  useEffect(() => {
    setOptionsValues(ownerTypeDetails.filter((ownerType)=>ownerType.isActive).map(ownerType => ({
      value: ownerType.ownerTypeId,
      label: ownerType.ownerTypeName,
    })));

    setVehicleTypeOptionsValues(vehicleTypeDetails.map(vehicleType => ({
      value: vehicleType.vehicleTypeId,
      label: vehicleType.vehicleTypeName,
    })));
  }, [vehicleTypeDetails]);


  useEffect(() => {
    setOptionLoadingValues(loadingEquipments.map(LoadingEquipment => ({
      value: LoadingEquipment.loadingEquipmentId,
      label: LoadingEquipment.loadingEquipmentNumber,
    })));
  }, [loadingEquipments]);


  useEffect(() => {
    localStorage.setItem('selectedOwnerType', selectedOwnerType);
  }, [selectedOwnerType]);


  useEffect(() => {
    localStorage.setItem('setSelectedLoadingEquipment', setSelectedLoadingEquipment);
  }, [setSelectedLoadingEquipment]);


  return (
    <>
      {isLoading ? ( // Check isLoading state and show loader if true
        <TableLoader height={500} />
      ) : (
        <div style={{ width: "100%" }}>
          <div className="content">
            <div className="page-content">
              <h4 class="text-start mb-3">{t("Loading Equipment Clearance Report ")} </h4>
              <div className="card">
                <div className="card-body p-3">
                  
                      <form className='row align-items-end'
                        onSubmit={handleFormSubmit}
                        style={{ textAlign: "justify" }}
                      >
                        <div className="col-md-2">
                          <label> From Date:</label>
                          <input
                            type="datetime-local"
                            name="FromDate"
                            style={inputStyle}
                            value={startDate}
                            className='form-control'
                            max={endDate ? endDate : getCurrentDateTime()}
                            onChange={(e) => setStartDate(e.target.value)}
                          />
                        </div>
                        <div className="col-md-2">
                          <label> To Date:</label>
                          <input
                            type="datetime-local"
                            name="ToDate"
                            style={inputStyle}
                            value={endDate}
                            className="form-control"
                            min={startDate}
                            max={getCurrentDateTime()}
                            onChange={(e) => setEndDate(e.target.value)}
                          />
                        </div>
                        <div className="col-md-2">
                          <label htmlFor="OwnerType">Owner Type:</label>
                          <CreatableSelect style={{ Height: '34px !important' }}
                            classNamePrefix="CreatableSelect"
                            inputId="ownerType"
                            name="ownerTypeId"
                            id="ownerType"
                            placeholder="Select"
                            options={optionsValues}
                            isClearable={true}
                            onChange={handleChange}
                            onCreateOption={(inputValue) => {

                              const newValue = { label: inputValue, value: inputValue.toLowerCase() };
                              { inputValue && newValue ? (setSelectedOwnerType(newValue.value)) : setSelectedOwnerType("  "); }
                              // setSelectedOwnerType(newValue.value);
                              // Add logic to update optionsValues with the new option if needed
                            }}
                            value={optionsValues.find((option) => option.value === selectedOwnerType)}
                          />
                        </div>
                        <div className="col-md-2">
                          <label htmlFor="VehicleType">Vehicle Type:</label>
                          <CreatableSelect style={{ Height: '34px !important' }}
                            classNamePrefix="CreatableSelect"
                            inputId="vehicleType"
                            name="vehicleTypeId"
                            id="vehicleType"
                            placeholder="Select"
                            options={vehicleTypeOptionsValues}
                            isClearable={true}
                            onChange={handleVehicleTypeChange}
                            onCreateOption={(inputValue) => {

                              const newValue = { label: inputValue, value: inputValue.toLowerCase() };
                              { inputValue && newValue ? (setSelectedVehicleType(newValue.value)) : setSelectedVehicleType("  "); }
                              // setSelectedOwnerType(newValue.value);
                              // Add logic to update optionsValues with the new option if needed
                            }}
                            value={vehicleTypeOptionsValues.find((option) => option.value === selectedVehicleType)}
                          />
                        </div>
                        <div className="col-md-2">
                          <label htmlFor="loadingEquipment" style={{ textAlign: 'left' }}>
                            Loading Equipment
                          </label>
                          <CreatableSelect style={{ Height: '34px !important' }}
                            classNamePrefix="CreatableSelect"
                            inputId="loadingEquipmentId"
                            name="loadingEquipmentId"
                            id="loadingEquipment"
                            placeholder="Select"
                            options={optionsLoadingValues}
                            isClearable={true}
                            onChange={handleLoadingEquipmentChange}
                            onCreateOption={handleCreateOption}
                            // onCreateOption={(inputValue) => {
                            //   const newValue = { label: inputValue, value: inputValue.toLowerCase() };
                            //   { inputValue && newValue ? (selectedLoadingEquipment(newValue.value)) : selectedLoadingEquipment("  "); }
                            //   // setSelectedOwnerType(newValue.value);
                            //   // Add logic to update optionsValues with the new option if needed
                            // }}
                            value={optionsLoadingValues.find((option) => option.value === selectedLoadingEquipment)}
                          />
                        </div>
                        <div className="col-md-12 justify-content-between align-items-end">
                          <div className="d-flex justify-content-end align-items-end">
                            <button type="submit" className={`btn mt-4 ${isProd ? "search-ghmc" : "search-swm"}`}>
                              Search
                            </button>
                            <div className="d-flex justify-content-end align-items-end">
                            <button className='btn-excel d-flex justify-content-end '
                              onClick={downloadAsExcel}
                            >
                              <i class="fa-solid fa-file-excel me-1 icon-container"></i> Excel
                            </button>
                          </div>
                          </div>
                        </div>
                      </form>


                  <div className="mt-3">
                    <TableComponent isLoading={isLoading}
                      hasTotalRow
                      DataFetchURL={getAllTripsTonnage}
                      headers={headers}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

// Rest of the component remains the same


export default withTranslation()(LoadingEquipmentClearenceReport);

// Styles for input and button

const inputStyle = {
  backgroundColor: "#fff",
  height: "38px",
  border: "1px solid #E2E2E2",
  padding: "15px",
  borderRadius: "0px",
};

const inputStyle2 = {
  backgroundColor: "#fff",
  height: "38px",
  border: "1px solid #E2E2E2",
  // padding: "15px",
  borderRadius: "0px",
};

const buttonStyle = {
};

const createOption = (label) => ({
  label,
  value: label.toLowerCase().replace(/\W/g, ''),
});

// Function to get the start of the current date (00:00 AM)
const getStartOfCurrentDate = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}T00:00`;
};

// Function to get current date and time in the required format
const getCurrentDateTime = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  const hour = String(now.getHours()).padStart(2, "0");
  const minute = String(now.getMinutes()).padStart(2, "0");
  return `${year}-${month}-${day}T${hour}:${minute}`;
};
